export default __webpack_public_path__ + "assets/fonts/a0a131ddc5e1888bbf5b561cbaaa88dc.woff";